import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Navbar.css';
import Logo from '../assets/logo1.png'
import lock from '../assets/lockk.png'

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <div className="logo-container">
            <img src={Logo} className="logo-icon" />
            <span className="logo-text">HAWL TECHNOLOGIES</span>
          </div>
        </Link>

        <div className="menu-icon" onClick={toggleMenu}>
          <i className={isMenuOpen ? 'fas fa-times' : 'fas fa-bars'} />
        </div>

        <ul className={isMenuOpen ? 'nav-menu active' : 'nav-menu'}>
          <li className="nav-item">
            <Link to="/" className="nav-link" onClick={() => setIsMenuOpen(false)}>
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/interview-config" className="nav-link" onClick={() => setIsMenuOpen(false)}>
              Practice Interview
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/" className="nav-link-pricing" onClick={() => setIsMenuOpen(false)}>
            <img src={lock} id="lockimage"></img>
              Pricing
            </Link>
          </li>
          <li className="nav-item">
            < Link to="/contactus" className="nav-link" onClick={() => setIsMenuOpen(false)}>
              Contact us
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/blog" className="nav-link" onClick={() => setIsMenuOpen(false)}>
              Blog
            </Link>
          </li>
          <li className="nav-item">
            < Link to="/login" className="nav-link login-box" onClick={() => setIsMenuOpen(false)}>
              Login
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar; 